import DropdownMenu, { DropdownItem, DropdownItemCheckbox, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { Filter } from '../filters';
import Button from '@atlaskit/button/new';
import { Filter as FilterIcon } from 'react-feather';

type FiltersDropdownProps = {
  filters: Filter[];
  selectedFilters: Filter[];
  onFilterToggle: (value: Filter) => void;
  onRemoveAll: () => void;
  limit?: number;
};

const FiltersDropdown = ({ filters, selectedFilters, onFilterToggle, onRemoveAll, limit }: FiltersDropdownProps) => {
  return (
    <DropdownMenu<HTMLButtonElement>
      trigger={({ triggerRef, ...props }) => (
        <Button {...props} type='button' appearance='primary' ref={triggerRef}>
          <span className='flex items-center'>
            <FilterIcon size={16} className='mr-2' />
            Filters
          </span>
        </Button>
      )}
    >
      <DropdownItemGroup>
        {filters.map((filter) => (
          <DropdownItemCheckbox
            key={filter.id}
            id={filter.id}
            onClick={() => onFilterToggle(filter)}
            isSelected={selectedFilters.some((selectedFilter) => selectedFilter.id === filter.id)}
            isDisabled={
              !!limit &&
              selectedFilters.length >= limit &&
              !selectedFilters.some((selectedFilter) => selectedFilter.id === filter.id)
            }
          >
            {filter.label}
          </DropdownItemCheckbox>
        ))}
      </DropdownItemGroup>
      <DropdownItemGroup hasSeparator>
        <DropdownItem onClick={onRemoveAll}>Remove all</DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>
  );
};

export default FiltersDropdown;
